(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function hav(a,b,c,d){var R=6371,p=Math.PI/180,x=Math.sin((c-a)*p/2)*Math.sin((c-a)*p/2)+Math.cos(a*p)*Math.cos(c*p)*Math.sin((d-b)*p/2)*Math.sin((d-b)*p/2);return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));}
  function loadLeaflet(cb){
    if(window.L){cb();return;}
    if(!document.getElementById('wkz-leaflet-css')){var l=document.createElement('link');l.id='wkz-leaflet-css';l.rel='stylesheet';l.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';document.head.appendChild(l);}
    var s=document.getElementById('wkz-leaflet-js');
    if(s){s.addEventListener('load',cb);return;}
    s=document.createElement('script');s.id='wkz-leaflet-js';s.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';s.onload=cb;document.head.appendChild(s);
  }
  function pin(){return L.divIcon({className:'wkz-pin',html:'<svg width="28" height="38" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 20 12 20s12-11 12-20C24 5.4 18.6 0 12 0z" fill="#e8341c"/><circle cx="12" cy="11" r="4.5" fill="#fff"/></svg>',iconSize:[28,38],iconAnchor:[14,38],popupAnchor:[0,-32]});}
  function initRoot(root){
    if(root.__init)return; root.__init=true;
    var mapEl=root.querySelector('[data-map]');
    var cards=[].slice.call(root.querySelectorAll('.wkz-loc__card'));
    if(mapEl){ loadLeaflet(function(){
      var map=L.map(mapEl,{scrollWheelZoom:false}).setView([30.3753,69.3451],5);
      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',{maxZoom:19,attribution:'Tiles &copy; Esri'}).addTo(map);
      var icon=pin(),bounds=[],byCity={};
      cards.forEach(function(c){
        var lat=parseFloat(c.getAttribute('data-lat')),lng=parseFloat(c.getAttribute('data-lng'));
        if(isNaN(lat)||isNaN(lng))return;
        var nm=(c.querySelector('.wkz-loc__name')||{}).textContent||'';
        var m=L.marker([lat,lng],{icon:icon}).addTo(map).bindPopup('<b>'+nm+'</b>');
        c.__m=m; bounds.push([lat,lng]);
        var cityEl=c.closest('.wkz-loc__city'); if(cityEl){var k=cityEl.getAttribute('data-city');(byCity[k]=byCity[k]||[]).push([lat,lng]);}
        c.addEventListener('click',function(e){ if(e.target.closest('a'))return; map.setView([lat,lng],14); m.openPopup(); });
      });
      if(bounds.length)map.fitBounds(bounds,{padding:[40,40]});
      setTimeout(function(){map.invalidateSize();},250);
      root.querySelectorAll('.wkz-loc__city-btn').forEach(function(btn){
        btn.addEventListener('click',function(){
          var city=btn.closest('.wkz-loc__city'),open=city.classList.contains('is-open');
          root.querySelectorAll('.wkz-loc__city').forEach(function(x){x.classList.remove('is-open');x.querySelector('.wkz-loc__city-btn').setAttribute('aria-expanded','false');});
          if(!open){city.classList.add('is-open');btn.setAttribute('aria-expanded','true');var pts=byCity[city.getAttribute('data-city')];if(pts&&pts.length){map.fitBounds(pts,{padding:[60,60],maxZoom:13});}setTimeout(function(){map.invalidateSize();},150);}
        });
      });
    }); }
    if(navigator.geolocation){navigator.geolocation.getCurrentPosition(function(pos){
      var ula=pos.coords.latitude,ulo=pos.coords.longitude;
      cards.forEach(function(c){var lat=parseFloat(c.getAttribute('data-lat')),lng=parseFloat(c.getAttribute('data-lng'));if(isNaN(lat)||isNaN(lng))return;var el=c.querySelector('[data-dist]');if(el)el.textContent=hav(ula,ulo,lat,lng).toFixed(1)+' KM';});
    },function(){},{timeout:8000,maximumAge:600000});}
  }
  function boot(){document.querySelectorAll('.wkz-loc').forEach(initRoot);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
